import { assignProps, removeItemByCode } from '@/utils/resultsHelper';
import { responseError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import actions from '../constants';
import { findDatasetMarkdown } from './state';

const fetchDatasetMarkdown = withDraft((draft, action) => {
  const item = findDatasetMarkdown(draft, action);

  if (item) {
    item.readStatus = states.PENDING;
    item.readErrors = [];
  } else {
    draft.markdowns[action.category].results.push({
      code: action.code,
      readErrors: [],
      readStatus: states.PENDING,
    });
  }
});

const fetchDatasetMarkdownSuccess = withDraft((draft, action) => {
  const item = findDatasetMarkdown(draft, action);
  assignProps(item, {
    ...action.result,
    readErrors: [],
    readStatus: states.SUCCESS,
  });
});

const fetchDatasetMarkdownError = withDraft((draft, action) => {
  const item = findDatasetMarkdown(draft, action);
  item.readStatus = states.ERROR;
  item.readErrors = [responseError(action)];
});

const closeDatasetMarkdown = withDraft((draft, action) => {
  const item = findDatasetMarkdown(draft, action);
  if (item) {
    draft.markdowns[action.category].results = removeItemByCode(draft.markdowns[action.category].results, item);
  }
});

export default {
  [actions.CLOSE_DATASET_MARKDOWN]: closeDatasetMarkdown,
  [actions.FETCH_DATASET_MARKDOWN]: fetchDatasetMarkdown,
  [actions.FETCH_DATASET_MARKDOWN_ERROR]: fetchDatasetMarkdownError,
  [actions.FETCH_DATASET_MARKDOWN_SUCCESS]: fetchDatasetMarkdownSuccess,
};
